import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** Positioned wrapper for a single node (its card plus the children block). */
export const Node = styled.div`
  position: relative;
`

/** Indented, dashed-rail container holding the node's nested child nodes. */
export const Children = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px dashed ${COLORS.border};
`

/** Positioned wrapper for one child so its connector can be absolutely placed. */
export const ChildWrap = styled.div`
  position: relative;
`

/** Horizontal elbow joining the dashed rail to a child card. */
export const Connector = styled.span`
  position: absolute;
  top: 26px;
  left: -20px;
  width: 20px;
  height: 1px;
  background-color: ${COLORS.border};
  pointer-events: none;
`
